import { ChangeEvent } from 'react';
import { cn } from 'utils/cn';
import ResponsiveDialog from "../ResponsiveDialog";
import SignupForm from "./signup-form";

export type SignupModalProps = {
    handleChangeEmail: (event: ChangeEvent<HTMLInputElement>) => void;
    handleChangeCompanyName: (event: any) => void;
    handleChangeName: (event: ChangeEvent<HTMLInputElement>) => void;
    handleGotoLogin: () => void;
    handleStartTrial: () => void;
    isRegisterPending: boolean;
    isTrialPending: boolean;
    email: string;
    name: string;
    projectScreenshot: string;
    collabMode: boolean;
    imageGraphicItem: any;
    itemType: string;
    projectUrl: string;
    itemDetails: any;
    handleChangeSignupOption: (value: string) => void
    logoSrc: string
    createError?: Record<string, string[]>
    trialError?: Record<string, string[]>
    teamSize: string;
    source: string;
    companyName: string;
    setTeamSize: (value: string) => void;
    setSource: (value: string) => void;
    registrationStepTwo: boolean;
    userData: any;
    comingFromMainSite: any;
    SignupOption: string;
    agreeToUserPrivacy: any;
    setAgreeToUserPrivacy: (value: boolean) => void;
    registerUser: (event: any) => void;
    handleGoogleRegister: (event: any) => void;
    container?: HTMLElement | ShadowRoot | null;
    showRightSide?: boolean;
};

export default function RegisterModal({
    handleChangeEmail,
    handleChangeName,
    handleGotoLogin,
    handleStartTrial,
    isRegisterPending,
    isTrialPending,
    email,
    name,
    itemDetails,
    projectUrl,
    projectScreenshot,
    collabMode,
    imageGraphicItem,
    itemType,
    handleChangeSignupOption,
    logoSrc,
    userData,
    registrationStepTwo,
    createError,
    trialError,
    teamSize,
    source,
    companyName,
    setTeamSize,
    setSource,
    handleChangeCompanyName,
    comingFromMainSite = false,
    SignupOption,
    agreeToUserPrivacy,
    setAgreeToUserPrivacy,
    registerUser,
    handleGoogleRegister,
    container,
    showRightSide = true,

}: SignupModalProps) {
    return (
        <>
            <ResponsiveDialog.Content
                container={container}
                className={cn('text-textcolor isolate m-auto my-0 max-w-[950px] border-none p-0 z-[99999] bg-transparent min-h-[45dvh] md:min-w-[420px] w-fit')}
                onEscapeKeyDown={(e) => { e.preventDefault(); }}
                onInteractOutside={(event: { preventDefault: () => any; }) => event.preventDefault()}
            >
                {/* <div className=""> */}
                <div className="max-w-[950px] mx-auto shadow-lg overflow-hidden rounded-[18px] bg-gradient-purple w-full h-full">
                    <div className="flex h-full">
                        <div
                            className={cn('bg-background w-full p-[30px_14px] m-3 rounded-lg flex flex-col justify-center')}
                        >
                            <div className="p-0">
                                <div className="text-textcolor flex flex-col items-center pt-8">
                                    <img
                                        src={logoSrc}
                                        className="mb-3 inline-flex max-w-[120px]"
                                        alt="Logo"
                                    />
                                    <div className="font-roboto text-textcolor mb-3 flex-grow self-center text-base font-bold">
                                        Dive Into Real-Time Collaboration
                                    </div>
                                </div>
                            </div>
                            <div className="px-6 pb-6 pt-0 text-sm">
                                {(createError || trialError) && <div>
                                    <ul>
                                        {Object.values(createError ?? trialError ?? {}).flat().map(e => <li>{e}</li>)}
                                    </ul>
                                </div>}
                                <SignupForm
                                    // loginUser={loginUser}
                                    handleChangeEmail={handleChangeEmail}
                                    handleChangeName={handleChangeName}
                                    handleGotoLogin={handleGotoLogin}
                                    isRegisterPending={isRegisterPending}
                                    isTrialPending={isTrialPending}
                                    email={email}
                                    name={name}
                                    // handleSetOpenRegister={handleSetOpenRegister}
                                    // setOpenLogin={setOpenLogin}
                                    // openLogin={openLogin}                                        
                                    teamSize={teamSize}
                                    source={source}
                                    companyName={companyName}
                                    setTeamSize={setTeamSize}
                                    setSource={setSource}
                                    handleChangeCompanyName={handleChangeCompanyName}
                                    handleStartTrial={handleStartTrial}
                                    registrationStepTwo={registrationStepTwo}
                                    userData={userData}
                                    comingFromMainSite={comingFromMainSite}
                                    SignupOption={SignupOption}
                                    agreeToUserPrivacy={agreeToUserPrivacy}
                                    setAgreeToUserPrivacy={setAgreeToUserPrivacy}
                                    registerUser={registerUser}
                                    handleGoogleRegister={handleGoogleRegister}
                                    collabMode={collabMode}
                                    itemDetails={itemDetails}
                                />
                            </div>
                        </div>
                        {/* )} */}
                        {/* {(showRightSide || comingFromMainSite) && (
                            <AuthRightSideDesign
                                projectScreenshot={projectScreenshot}
                                projectUrl={projectUrl}
                                collabMode={collabMode}
                                imageGraphicItem={imageGraphicItem}
                                itemType={itemType}
                                itemDetails={itemDetails}
                            />
                        )} */}
                    </div>
                </div>
                {/* </div> */}
            </ResponsiveDialog.Content>
        </>
    );
}